import { getTagSections as getTagSectionsHttp } from '@wix/ambassador-appmarket-v1-app-market-client-aggregator/http';
import type {
  GetTagSectionsRequest,
  GetTagSectionsResponse,
} from '@wix/ambassador-appmarket-v1-app-market-client-aggregator/types';

import type { Essentials } from '../../../models';
import type { AppGroupSection } from '../../../types/sections';
import { isSSR } from '../../../utils/is-ssr';

export async function getAppGroupSectionsBySubCategoriesIds({
  httpClient,
  rpcClient,
  subCategoriesIds,
}: {
  httpClient: Essentials['httpClient'];
  rpcClient: Essentials['rpcClient'];
  subCategoriesIds: string[];
}): Promise<AppGroupSection[]> {
  const getTagSectionsResponse = await getTagSections({
    httpClient,
    rpcClient,
    tagIds: subCategoriesIds,
  });

  const { sections = [] } = getTagSectionsResponse;

  return sections.map((section) => section.appGroup as AppGroupSection);
}

async function getTagSections({
  httpClient,
  rpcClient,
  tagIds,
}: {
  httpClient: Essentials['httpClient'];
  rpcClient: Essentials['rpcClient'];
  tagIds: string[];
}): Promise<GetTagSectionsResponse> {
  const getTagSectionsRequest: GetTagSectionsRequest = {
    tagIds,
  };

  if (isSSR() && rpcClient !== undefined) {
    const getTagSectionsRpc = (
      await import(
        '@wix/ambassador-appmarket-v1-app-market-client-aggregator/rpc'
      )
    ).getTagSections;
    return rpcClient.request(getTagSectionsRpc(getTagSectionsRequest));
  }

  const { data: getTagSectionsResponse } = await httpClient.request(
    getTagSectionsHttp(getTagSectionsRequest),
  );

  return getTagSectionsResponse;
}
